class DossierCircuit {
    constructor(
        date,
        programme,
        toClient,
        numeroFacture,
        methodePaiement,
        dateVolArrivee,
        heureVolArrivee,
        numeroVolArrivee,
        compagnieVolArrivee,
        dateVolDepart,
        heureVolDepart,
        numeroVolDepart,
        compagnieVolDepart,
        pax,
        commentaire,
        chauffeur,
        guide,
        vehicule,
        isGroup = false,
        rooming = [],
        hotels = [],
        excursions = [],
        transferts = [],
        locations = [],
        envelops = [],
        frais = []
    ) {

 
        this.pax = pax;
        this.nombreJour = null;
        this.toClient = toClient || null;
        this.nomClient = null;
        this.methodePaiement = methodePaiement || "Autre"; 
        this.dateVolArrivee = dateVolArrivee || null;
        this.heureVolArrivee = heureVolArrivee || null;
        this.numeroVolArrivee = numeroVolArrivee || null;
        this.compagnieVolArrivee = compagnieVolArrivee || null;
        this.dateVolDepart = dateVolDepart || null;
        this.heureVolDepart = heureVolDepart || null;
        this.numeroVolDepart = numeroVolDepart || null;
        this.compagnieVolDepart = compagnieVolDepart || null;
        this.commentaire = commentaire || null;
        this.chauffeur = chauffeur || null;
        this.guide = guide || null;
        this.vehicule = vehicule || null;
        this.isGroup = isGroup;
        this.rooming = rooming;
        this.hotels = hotels;
        this.excursions = excursions;
        this.transferts = transferts;
        this.locations = locations;
        this.envelops = envelops;
        this.frais = frais;
        this.numeroFacture = numeroFacture || null;
        this.date = date || null;
    }
}


export default DossierCircuit;